import { ChangeDetectorRef, EventEmitter, Output } from "@angular/core";
import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormArray, FormBuilder, FormControl } from "@angular/forms";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { UserService } from "../service/user.service";
import { Log } from "../util/log";
import { Overlay } from '@angular/cdk/overlay';
import { ActivationCode } from "../model/activationCode";
import { DateHelper } from "../util/dateHelper";
import { ConfirmDialogComponent } from "../confirm-dialog/confirm-dialog.component";

@Component({
  selector: 'app-code-description-dialog',
  templateUrl: './code-description-dialog.component.html',
  styleUrls: ['./code-description-dialog.component.css']
})
export class CodeDescriptionDialogComponent implements OnInit {

  currentDescription: string;
  activationCodesForm: FormGroup;
  editDescriptionForm = new FormGroup({
    description: new FormControl('')
  });
  newDescription: string;

  constructor(
    public dialogRef: MatDialogRef<CodeDescriptionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private cdRef: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private overlay: Overlay
  ) {
    this.newDescription = data.currentDescription;
  }

  ngOnInit(): void {
    this.activationCodesForm = this.formBuilder.group({
      editDescriptionForm: this.editDescriptionForm
    });
  }

  confirm() {
    this.dialogRef.close(this.newDescription);
  }

  cancel() {
    this.dialogRef.close();
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
